import axios from 'axios'

const baseURL = process.env.VUE_APP_DROP_ORDER_SERVICE + '/api/admin/promo-codes'

export default {
  namespaced: true,
  state: {
    is_loading: null,
    is_processing: null,
    promoCodes: [],
    pagination: {
      last_page: 1
    }
  },
  mutations: {
    setPromoCodes (state, payload) {
      state.promoCodes = payload
    },
    setPagination (state, payload) {
      state.pagination = payload
    }
  },
  actions: {
    async getPromoCodes ({ commit, state }, filters) {
      state.is_loading = true
      const promise = axios.get(baseURL, {
        params: filters
      })

      promise.then(response => {
        commit('setPromoCodes', response.data.data)
        commit('setPagination', { last_page: response.data.last_page })
        state.is_loading = false
      })
    },
    async createPromoCode ({ commit, state }, data) {
      state.is_processing = true
      const promise = axios.post(baseURL, data)

      promise.then(() => {
        state.is_processing = false
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    },
    async deletePromoCode ({ commit, state }, id) {
      state.is_processing = true
      const promise = axios.delete(baseURL + '/' + id)

      promise.then(() => {
        state.is_processing = false
      }).catch(() => {
        state.is_processing = false
      })

      return promise
    }
  }
}
